<template>
  <transition name="fade">
    <div v-if="open" class="z-modal z-modal--is-open" @click="closeModalOnOutsideClick($event)">
      <div :class="`z-modal__wrapper ${medium ? 'z-modal__wrapper--medium': ''}`">
        <button
          aria-label="Fechar"
          title="Fechar"
          class="z-modal__close-button"
          @click="$emit('close')"
        >
          <img
            type="image/svg+xml"
            :src="require('assets/images/icons/i-close.svg')"
            alt="Fechar"
          >
        </button>
        <div class="z-modal__dialog">
          <slot name="header"></slot>
          <hr v-if="$slots.header && $slots.body" class="divider--no-border divider--spaced-s">
          <slot name="body"></slot>
          <hr v-if="$slots.footer && $slots.body" class="divider--no-border divider--spaced-s">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>
<style lang="scss" scoped>
@import '@quero/zilla-core/src/utils/variables.scss';

.divider--no-border {
  border: none;
}

.fade-enter {
  opacity: 0;
  .z-modal__wrapper {
    transform: translateY(-50%);
  }
}
.fade-enter-to {
  .z-modal__wrapper {
    transform: translateY(0);
  }
}
.fade-leave {
  .z-modal__wrapper {
    transform: translateY(0);
  }
}
.fade-leave-to {
  opacity: 0;
  .z-modal__wrapper {
    transform: translateY(-50%)
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
  .z-modal__wrapper  {
    transition: all 300ms ease-in-out;
  }
}
.z-modal__close-button img {
  fill: white;
  height: 14px;
  width: 14px;
}

.z-modal {
  z-index: 10;
}

.z-modal__dialog {
  @media screen and (max-width: $screen-xs-max) {
    padding: var(--space-extra-large);
  }
}

.z-modal__wrapper--medium {
  max-width: 430px;
}
</style>
<script>
import closeIcon from 'assets/images/icons/i-close.svg';

export default {
  name: 'Modal',
  props: {
    medium: {
      type: Boolean,
    },
    open: {
      type: Boolean,
    },
    allowClickOutside: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icons: {
        closeIcon,
      },
    };
  },
  methods: {
    closeModalOnOutsideClick(e) {
      if (!this.allowClickOutside && e.target.classList.contains('z-modal')) {
        e.preventDefault();
        e.stopPropagation();
        this.$emit('close');
      }
    },
  },
};
</script>
